<kendo-appbar section [ngStyle]="{ 'background-color': '#193971' }"
  position="bottom" height="45px">
<div class="copyrightContainer footerForRest">
  <div class="copyText row">
    <div class="col-md-5">©2023 CRAWFORD & COMPANY. All Rights Reserved.</div>
  </div>
</div>
</kendo-appbar>
